export default "__VITE_ASSET__Cf$px52w__"